import HeadingComponent from "../UserInterface/HeadingComponent";
import Description from "../UserInterface/Description";
import { DownloadLink } from "../UserInterface/DownloadLink";

type AboutTataKelolaProps = {
  title: string;
  description: string;
  downloadIcon: string;
};

const AboutTataKelola = ({
  title,
  description,
  downloadIcon
}: AboutTataKelolaProps) => (
  <>
    <HeadingComponent headingText={title} />
    <Description margin="16px" font="Roboto" width="940px" text={description} />
    <div className="pdf-links">
      <DownloadLink
        width="550px"
        img={downloadIcon}
        linkName="Kebijakan Tata Kelola Perusahaan yang Baik"
        url="/static/pdf/Summary-GCG.pdf"
      />
      <DownloadLink
        width="550px"
        img={downloadIcon}
        linkName="Laporan Keberlanjutan 2023"
        url="/static/pdf/Laporan_Keberlanjutan_PT_Home_Credit_Indonesia_Tahun_2023_.pdf"
      />
    </div>
    <style jsx>{`
      .pdf-links {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 40px;
      }
    `}</style>
  </>
);

export default AboutTataKelola;
